export default __webpack_public_path__ + "images/0x0f929c29dce303f96b1d4104505f2e60ee795cac.png";